import { Popover, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useParticipant } from "@videosdk.live/react-sdk";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useMediaQuery } from "react-responsive";
import useIsMobile from "../../../hooks/useIsMobile";
import useIsTab from "../../../hooks/useIsTab";
import useWindowSize from "../../../hooks/useWindowSize";
import MicOffSmallIcon from "../../../assets/icons/MicOffSmallIcon";
import NetworkIcon from "../../../assets/icons/NetworkIcon";
import SpeakerIcon from "../../../assets/icons/SpeakerIcon";
import { getQualityScore, nameTructed } from "../../../utils/common";
import * as ReactDOM from "react-dom";
import { useMeetingAppContext } from "../../../hooks/MeetingAppContextDef";
import html2canvas from "html2canvas";
import ShareScreenIcon from "../../../assets/images/share-screen.svg";
import QrCodeIcon from "../../../assets/images/qrcode-svgrepo-com.svg";
import { useMeeting } from "@videosdk.live/react-sdk";
import ContactSupportPage from "../../commonComponents/ContactSupportPage";
import ConfirmBox from "../../commonComponents/ConfirmBox";
import { encryptToken } from "../../../utils/decryptURL";
import { QRCodeSVG } from "qrcode.react";
export const CornerDisplayName = ({
  participantId,
  isPresenting,
  displayName,
  isLocal,
  micOn,
  mouseOver,
  isActiveSpeaker,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [qrModalOpen, setQrModalOpen] = useState(false);

  const mobileProctoringEnabled =
    sessionStorage.getItem("mobileProctoringVideo") === "true";

  const interviewId = sessionStorage.getItem("interviewId");
  const companyId = sessionStorage.getItem("companyId");
  const timeRestriction = sessionStorage.getItem("time_restriction");
  const qrPayload = `${companyId},${interviewId},${timeRestriction}`;
  const { toggleScreenShare, localScreenShareOn } = useMeeting();
  const isMobile = useIsMobile();
  const isTab = useIsTab();
  const isLGDesktop = useMediaQuery({ minWidth: 1024, maxWidth: 1439 });
  const isXLDesktop = useMediaQuery({ minWidth: 1440 });
const [fbkrecieved, setfbkRecieved] = useState(
    () => sessionStorage.getItem("fbk-received") === "true"
  );
  useEffect(() => {
    const styleId = "network-toast-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateX(-50%) translateY(-12px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);
useEffect(() => {
  const handleFbkReceived = () => {
    sessionStorage.setItem("fbk-received", "true");
    setfbkRecieved(true);
  };

  window.addEventListener("fbk-received", handleFbkReceived);

  return () => {
    window.removeEventListener("fbk-received", handleFbkReceived);
  };
}, []);
  const { height: windowHeight } = useWindowSize();

  const [statsBoxHeightRef, setStatsBoxHeightRef] = useState(null);
  const [statsBoxWidthRef, setStatsBoxWidthRef] = useState(null);

  const [coords, setCoords] = useState({}); // takes current button coordinates

  const statsBoxHeight = useMemo(
    () => statsBoxHeightRef?.offsetHeight,
    [statsBoxHeightRef],
  );

  const statsBoxWidth = useMemo(
    () => statsBoxWidthRef?.offsetWidth,
    [statsBoxWidthRef],
  );

  const analyzerSize = isXLDesktop
    ? 32
    : isLGDesktop
      ? 28
      : isTab
        ? 24
        : isMobile
          ? 20
          : 18;

  const show = useMemo(() => mouseOver, [mouseOver]);

  const {
    webcamStream,
    micStream,
    screenShareStream,
    getVideoStats,
    getAudioStats,
    getShareStats,
    getShareAudioStats,
  } = useParticipant(participantId);

  const statsIntervalIdRef = useRef();
  const [score, setScore] = useState({});
  const [audioStats, setAudioStats] = useState({});
  const [videoStats, setVideoStats] = useState({});
  const [showNetworkToast, setShowNetworkToast] = useState(false);
  const toastTimeoutRef = useRef(null);
  const wasUnstableRef = useRef(false);

  useEffect(() => {
    if (score !== null && score !== undefined && typeof score === "number") {
      if (score <= 4 && !wasUnstableRef.current) {
        wasUnstableRef.current = true;
        setShowNetworkToast(true);
        if (toastTimeoutRef.current) clearTimeout(toastTimeoutRef.current);
        toastTimeoutRef.current = setTimeout(() => {
          setShowNetworkToast(false);
        }, 5000);
      } else if (score > 4) {
        wasUnstableRef.current = false;
        setShowNetworkToast(false);
        if (toastTimeoutRef.current) clearTimeout(toastTimeoutRef.current);
      }
    }
    return () => {
      if (toastTimeoutRef.current) clearTimeout(toastTimeoutRef.current);
    };
  }, [score]);

  const updateStats = async () => {
    let stats = [];
    let audioStats = [];
    let videoStats = [];
    if (isPresenting) {
      stats = await getShareStats();
    } else if (webcamStream) {
      stats = await getVideoStats();
    } else if (micStream) {
      stats = await getAudioStats();
    }

    if (webcamStream || micStream || isPresenting) {
      videoStats = isPresenting ? await getShareStats() : await getVideoStats();
      audioStats = isPresenting
        ? await getShareAudioStats()
        : await getAudioStats();
    }

    let score = stats
      ? stats.length > 0
        ? getQualityScore(stats[0])
        : 100
      : 100;

    setScore(score);
    setAudioStats(audioStats);
    setVideoStats(videoStats);
  };
  const handleSupportProceed = async () => {
    setConfirmOpen(false);

    const canvas = await html2canvas(document.body);
    const img = canvas.toDataURL("image/png");

    sessionStorage.setItem("supportScreenshot", img);
    sessionStorage.setItem("supportName", displayName);
    const interviewId = sessionStorage.getItem("interviewId");
    const companyId = sessionStorage.getItem("companyId");

    // encrypt ids
    const encryptedInterviewId = await encryptToken(interviewId);
    const encryptedCompanyId = await encryptToken(companyId);

    const url = `https://needlestacks.ai/support/?assessmentId=${encodeURIComponent(
      encryptedInterviewId,
    )}&companyId=${encodeURIComponent(encryptedCompanyId)}`;

    window.open(url, "_blank");
  };
  const qualityStateArray = [
    { label: "", audio: "Audio", video: "Video" },
    {
      label: "Latency",
      audio:
        audioStats && audioStats[0]?.rtt ? `${audioStats[0]?.rtt} ms` : "-",
      video:
        videoStats && videoStats[0]?.rtt ? `${videoStats[0]?.rtt} ms` : "-",
    },
    {
      label: "Jitter",
      audio:
        audioStats && audioStats[0]?.jitter
          ? `${parseFloat(audioStats[0]?.jitter).toFixed(2)} ms`
          : "-",
      video:
        videoStats && videoStats[0]?.jitter
          ? `${parseFloat(videoStats[0]?.jitter).toFixed(2)} ms`
          : "-",
    },
    {
      label: "Packet Loss",
      audio: audioStats
        ? audioStats[0]?.packetsLost
          ? `${parseFloat(
              (audioStats[0]?.packetsLost * 100) / audioStats[0]?.totalPackets,
            ).toFixed(2)}%`
          : "-"
        : "-",
      video: videoStats
        ? videoStats[0]?.packetsLost
          ? `${parseFloat(
              (videoStats[0]?.packetsLost * 100) / videoStats[0]?.totalPackets,
            ).toFixed(2)}%`
          : "-"
        : "-",
    },
    {
      label: "Bitrate",
      audio:
        audioStats && audioStats[0]?.bitrate
          ? `${parseFloat(audioStats[0]?.bitrate).toFixed(2)} kb/s`
          : "-",
      video:
        videoStats && videoStats[0]?.bitrate
          ? `${parseFloat(videoStats[0]?.bitrate).toFixed(2)} kb/s`
          : "-",
    },
    {
      label: "Frame rate",
      audio: "-",
      video:
        videoStats &&
        (videoStats[0]?.size?.framerate === null ||
          videoStats[0]?.size?.framerate === undefined)
          ? "-"
          : `${videoStats ? videoStats[0]?.size?.framerate : "-"}`,
    },
    {
      label: "Resolution",
      audio: "-",
      video: videoStats
        ? videoStats && videoStats[0]?.size?.width === null
          ? "-"
          : `${videoStats[0]?.size?.width}x${videoStats[0]?.size?.height}`
        : "-",
    },
    {
      label: "Codec",
      audio: audioStats && audioStats[0]?.codec ? audioStats[0]?.codec : "-",
      video: videoStats && videoStats[0]?.codec ? videoStats[0]?.codec : "-",
    },
    {
      label: "Cur. Layers",
      audio: "-",
      video:
        videoStats && !isLocal
          ? videoStats && videoStats[0]?.currentSpatialLayer === null
            ? "-"
            : `S:${videoStats[0]?.currentSpatialLayer || 0} T:${
                videoStats[0]?.currentTemporalLayer || 0
              }`
          : "-",
    },
    {
      label: "Pref. Layers",
      audio: "-",
      video:
        videoStats && !isLocal
          ? videoStats && videoStats[0]?.preferredSpatialLayer === null
            ? "-"
            : `S:${videoStats[0]?.preferredSpatialLayer || 0} T:${
                videoStats[0]?.preferredTemporalLayer || 0
              }`
          : "-",
    },
  ];

  useEffect(() => {
    if (webcamStream || micStream || screenShareStream) {
      updateStats();

      if (statsIntervalIdRef.current) {
        clearInterval(statsIntervalIdRef.current);
      }

      statsIntervalIdRef.current = setInterval(updateStats, 500);
    } else {
      if (statsIntervalIdRef.current) {
        clearInterval(statsIntervalIdRef.current);
        statsIntervalIdRef.current = null;
      }
    }

    return () => {
      if (statsIntervalIdRef.current) clearInterval(statsIntervalIdRef.current);
    };
  }, [webcamStream, micStream, screenShareStream]);

  return (
    <>
      {/* QR Code sync button — shown only when mobileProctoringVideo is enabled */}
      {/* {mobileProctoringEnabled && !fbkrecieved&& (
        <div className="absolute bottom-[116px] left-[10px]">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setQrModalOpen(true);
            }}
            className="relative group flex items-center justify-center rounded-full"
            style={{
              width: 54,
              height: 54,
              background: "#111729",
              opacity: 0.9,
              border: "1px solid #fff",
            }}
          >
            <img
              src={QrCodeIcon}
              alt="QR Code"
              style={{ width: 30, height: 30, filter: "invert(1)" }}
            />
          <div
  className="custom-tooltip"
  style={{
    left: "calc(100% + 12px)",
    bottom: "50%",
    transform: "translateX(0) translateY(50%)",
    width: "220px",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    boxSizing: "border-box",
  }}
>
  Click here to scan and sync your NeedleEye Mobile app with the assessment.
  <span
    className="custom-tooltip-arrow"
    style={{
      left: "-7px",
      bottom: "50%",
      transform: "translateY(50%) rotate(135deg)",
    }}
  />
</div>
          </button>
        </div>
      )} */}

      <div className="absolute bottom-[52px] left-[10px]">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmOpen(true);
          }}
          className="relative group flex items-center justify-center rounded-full"
          style={{
            width: 54,
            height: 54,
            background: "#111729",
            opacity: 0.9,
            border: "1px solid #fff",
          }}
        >
          <span className="text-white text-[25px]  font-semibold">?</span>

          <div
            className="custom-tooltip"
            style={{
              left: "calc(100% + 12px)",
              bottom: "50%",
              transform: "translateX(0) translateY(50%)",
            }}
          >
            Reach out to Support / Help Desk
            <span
              className="custom-tooltip-arrow"
              style={{
                left: "-7px",
                bottom: "50%",
                transform: "translateY(50%) rotate(135deg)",
              }}
            />
          </div>
        </button>
      </div>
      {/*  Share icon always visible (only local user) */}
      {/* {isLocal && (
        <button
          type="button"
          title={localScreenShareOn ? "Stop sharing" : "Share screen"}
          onClick={(e) => {
            e.stopPropagation();
            toggleScreenShare();
          }}
          className="absolute left-2 bottom-[100px] z-[99]
     flex items-center justify-center rounded-full
     hover:bg-white/20 active:scale-95 transition
     relative group"
          style={{ marginTop: "-10px" }}
          // style={{
          //   width: 44,
          //   height: 44,
          //   backdropFilter: "blur(10px)",
          //   WebkitBackdropFilter: "blur(10px)",
          // }}
        >
          <img
            src={ShareScreenIcon}
            alt="share"
            style={{
              width: 70,
              height: 70,
              opacity: localScreenShareOn ? 1 : 0.9,
            }}
          />
          <div className="custom-tooltip custom-tooltip-left z-[90]">
            {localScreenShareOn ? "Stop sharing" : "Share Screen"}
            <span className="custom-tooltip-arrow custom-tooltip-arrow-left" />
          </div>
        </button>
      )} */}

      {/* bottom-left name badge (hover based) */}
      <div
        className="absolute bottom-2 left-2 rounded-md flex items-center justify-center gap-2 px-2 py-1.5"
        style={{
          backgroundColor: "rgba(17, 23, 41, 0.85)",
          transition: "all 200ms linear",
          transform: `scale(${show ? 1 : 0})`,
          transformOrigin: "left bottom",
        }}
      >
        {/* mic / speaker indicator */}
        {!micOn && !isPresenting ? (
          <MicOffSmallIcon fillcolor="white" />
        ) : micOn && isActiveSpeaker ? (
          <SpeakerIcon />
        ) : null}

        {/* name */}
        <p className="text-sm text-white ml-0.5 whitespace-nowrap">
          {isPresenting
            ? isLocal
              ? `You are presenting`
              : `${nameTructed(displayName, 15)} is presenting`
            : isLocal
              ? "You"
              : nameTructed(displayName, 26)}
        </p>
      </div>

      {(webcamStream || micStream || screenShareStream) && (
        <div>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="absolute top-2 right-2 rounded-md  p-2 cursor-pointer "
          >
            <Popover className="relative ">
              {({ close }) => (
                <>
                  <Popover.Button
                    className={`absolute right-0 top-0 rounded-md flex items-center justify-center p-1.5 cursor-pointer`}
                    style={{
                      backgroundColor:
                        score > 7
                          ? "#3BA55D"
                          : score > 4
                            ? "#faa713"
                            : "#FF5D5D",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const rect = e.target.getBoundingClientRect();
                      setCoords({
                        left: Math.round(rect.x + rect.width / 2),
                        top: Math.round(rect.y + window.scrollY),
                      });
                    }}
                  >
                    <div>
                      <NetworkIcon
                        color1={"#ffffff"}
                        color2={"#ffffff"}
                        color3={"#ffffff"}
                        color4={"#ffffff"}
                        style={{
                          height: analyzerSize * 0.6,
                          width: analyzerSize * 0.6,
                        }}
                      />
                    </div>
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel style={{ zIndex: 999 }} className="absolute">
                      {ReactDOM.createPortal(
                        <div
                          ref={setStatsBoxWidthRef}
                          style={{
                            top:
                              coords?.top + statsBoxHeight > windowHeight
                                ? windowHeight - statsBoxHeight - 20
                                : coords?.top,
                            left:
                              coords?.left - statsBoxWidth < 0
                                ? 12
                                : coords?.left - statsBoxWidth,
                          }}
                          className={`absolute`}
                        >
                          <div
                            ref={setStatsBoxHeightRef}
                            className="bg-gray-800 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 "
                          >
                            <div
                              className={`p-[9px] flex items-center justify-between rounded-t-lg`}
                              style={{
                                backgroundColor:
                                  score > 7
                                    ? "#3BA55D"
                                    : score > 4
                                      ? "#faa713"
                                      : "#FF5D5D",
                              }}
                            >
                              <p className="text-sm text-white font-semibold">{`Quality Score : ${
                                score > 7
                                  ? "Good"
                                  : score > 4
                                    ? "Average"
                                    : "Poor"
                              }`}</p>

                              <button
                                className="cursor-pointer text-white hover:bg-[#ffffff33] rounded-full px-1 text-center"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  close();
                                }}
                              >
                                <XMarkIcon
                                  className="text-white"
                                  style={{ height: 16, width: 16 }}
                                />
                              </button>
                            </div>

                            <div className="flex">
                              <div className="flex flex-col">
                                {qualityStateArray.map((item, index) => {
                                  return (
                                    <div
                                      key={`quality-row-${item.label || index}`}
                                      className="flex"
                                      style={{
                                        borderBottom:
                                          index === qualityStateArray.length - 1
                                            ? ""
                                            : `1px solid #ffffff33`,
                                      }}
                                    >
                                      <div className="flex flex-1 items-center w-[120px]">
                                        {index !== 0 && (
                                          <p className="text-xs text-white my-[6px] ml-2">
                                            {item.label}
                                          </p>
                                        )}
                                      </div>

                                      <div
                                        className="flex flex-1 items-center justify-center"
                                        style={{
                                          borderLeft: `1px solid #ffffff33`,
                                        }}
                                      >
                                        <p className="text-xs text-white my-[6px] w-[80px] text-center">
                                          {item.audio}
                                        </p>
                                      </div>

                                      <div
                                        className="flex flex-1 items-center justify-center"
                                        style={{
                                          borderLeft: `1px solid #ffffff33`,
                                        }}
                                      >
                                        <p className="text-xs text-white my-[6px] w-[80px] text-center">
                                          {item.video}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>,
                        document.body,
                      )}
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </div>
        </div>
      )}
      <ConfirmBox
        open={confirmOpen}
        title="Contact Support / Help Desk"
        subTitle="You chose to reach out to Support / Help Desk.

Are you sure you want to proceed?"
        successText="Yes"
        rejectText="Cancel"
        onSuccess={handleSupportProceed}
        onReject={() => setConfirmOpen(false)}
      />

      {/* QR Modal — Sync NeedleEye Mobile App */}
      {mobileProctoringEnabled &&
        qrModalOpen &&
        ReactDOM.createPortal(
          <div
            onClick={() => setQrModalOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 99999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.30)",
               padding:10,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#1A1C22",
                borderRadius: 6,
                padding: 30,
                width: "100%",
                maxWidth: 448,
                position: "relative",
                boxShadow:
                  "0 20px 25px -5px rgba(0,0,0,0.4), 0 10px 10px -5px rgba(0,0,0,0.2)",
              }}
            >
              {/* Close X — top right */}
              <button
                type="button"
                onClick={() => setQrModalOpen(false)}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "#9FA0A7",
                  padding: 4,
                  lineHeight: 1,
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#232830")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
                aria-label="Close"
              >
                <XMarkIcon style={{ width: 16, height: 16 }} />
              </button>
              {/* Title */}
              <p
                style={{
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 500,
                  margin: 0,
                  paddingRight: 24,
                }}
              >
                Sync NeedleEye Mobile App
              </p>

              {/* Subtitle */}
              <p
                style={{
                  color: "#9FA0A7",
                  fontSize: 13,
                  marginTop: 8,
                  marginBottom: 0,
                }}
              >
                Scan this QR code with the NeedleEye Mobile app to sync with
                this assessment.
              </p>

              {/* QR Code */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 16,
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 8,
                    padding: 12,
                    display: "inline-flex",
                  }}
                >
                  <QRCodeSVG value={qrPayload} size={220} />
                </div>
              </div>

              {/* OK button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <button
                  type="button"
                  onClick={() => setQrModalOpen(false)}
                  style={{
                    background: "transparent",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 16px",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#232830")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  OK
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {showNetworkToast &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: 20,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 99999,
              backgroundColor: "#FF5D5D",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: 8,
              boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontSize: 16, // was 14
              fontWeight: 600, // was 500
              maxWidth: 620, // was 420
              width: "100%",
              animation: "fadeInDown 0.3s ease",
            }}
          >
            <span style={{ fontSize: 20 }}>⚠️</span>
            <span>
              Your network is unstable. Please switch to a more stable
              connection for the best experience.
            </span>
            <button
              onClick={() => setShowNetworkToast(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                marginLeft: 8,
                fontSize: 16,
                lineHeight: 1,
                padding: 0,
              }}
              aria-label="Dismiss"
            >
              ✕
            </button>
          </div>,
          document.body,
        )}
    </>
  );
};

export function ParticipantView({ participantId }) {
  const {
    displayName,
    webcamStream,
    micStream,
    webcamOn,
    micOn,
    isLocal,
    mode,
    isActiveSpeaker,
  } = useParticipant(participantId);

  const { selectedSpeaker } = useMeetingAppContext();
  const micRef = useRef(null);
  const [mouseOver, setMouseOver] = useState(false);

  useEffect(() => {
    const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    if (micRef.current) {
      try {
        if (!isFirefox) {
          micRef.current.setSinkId(selectedSpeaker.id);
        }
      } catch (err) {
        console.log("Setting speaker device failed", err);
      }
    }
  }, [selectedSpeaker]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) =>
            console.error("micRef.current.play() failed", error),
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn, micRef]);

  const webcamMediaStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
  }, [webcamStream, webcamOn]);
  return mode === "SEND_AND_RECV" ? (
    <div
      onMouseEnter={() => {
        setMouseOver(true);
      }}
      onMouseLeave={() => {
        setMouseOver(false);
      }}
      className={`h-full w-full  bg-gray-750 relative overflow-hidden rounded-lg video-cover`}
    >
      <audio ref={micRef} autoPlay muted={isLocal} />
      {webcamOn ? (
        <ReactPlayer
          //
          playsinline // very very imp prop
          playIcon={<></>}
          //
          // pip={false}
          light={false}
          controls={false}
          muted={true}
          playing={true}
          //
          url={webcamMediaStream}
          //
          height={"100%"}
          width={"100%"}
          onError={(err) => {
            console.log(err, "participant video error");
          }}
        />
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <div
            className={`z-10 flex items-center justify-center rounded-full bg-gray-800 2xl:h-[92px] h-[52px] 2xl:w-[92px] w-[52px]`}
          >
            <p className="text-2xl text-white">
              {String(displayName).charAt(0).toUpperCase()}
            </p>
          </div>
        </div>
      )}
      <CornerDisplayName
        {...{
          isLocal,
          displayName,
          micOn,
          webcamOn,
          isPresenting: false,
          participantId,
          mouseOver,
          isActiveSpeaker,
        }}
      />
    </div>
  ) : null;
}
